<template>
  <!-- eslint-disable max-len -->
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">音楽著作権の期間及び限定譲渡に関する規約（著作権管理サービス）</h3>
    </div>
    <div class="page-block__inner">
      <div
        v-if="isBtoC"
        class="terms-area">
        <div class="terms-text__box">
          <p>
            本音楽著作権の期間及び限定譲渡に関する規約（著作権管理サービス）（以下「本規約」といいます。）は、アカウント管理者が、その音楽著作権を本規約に定める有効期間中、株式会社ローディアム（以下「当社」といいます。）に譲渡することにより、同社が提供する音楽著作物の著作権管理サービスを利用する際の諸条件を定めるものです。<br>
            本規約に別段の定めがない事項については、「narasu」著作権管理サービス利用規約（以下「著作権管理サービス利用規約」といいます。）その他の関連規約が適用され、本規約において用いる用語の定義は、本規約において特段の定めがない限り、著作権管理サービス利用規約の定義に従うものとします。<br>
            本サービスの利用を希望される方は、本規約をよくお読み頂き、同意の上お申し込み下さい。本サービスの利用のお申し込みをされた場合、本規約に同意されたものとみなします。本規約に同意いただけない場合、利用のお申し込みをすることはできません。<br>
            18歳未満の方は、親権者等の法定代理人の同意が必要となります。なお、アカウント管理者が18歳未満の場合に、本サービスを利用した時点で、親権者等の法定代理人の同意が得られているものとします。<br>
          </p>
        </div>

        <h4>第１条：目的</h4>
        <div class="terms-text__box">
          コンテンツの著作権の管理を行うことを目的として、アカウント管理者は、コンテンツの著作権を、本規約の諸条項に従い、本規約に基づく著作権譲渡の有効期間中、当社に対し独占的に譲渡します。
        </div>

        <h4>第２条：保証</h4>
        <div class="terms-text__box">
          アカウント管理者は、当社に対し、コンテンツが著作者（アカウント管理者が当社に届け出た著作者をいいます）の創作による完全な著作物であること、本規約に従い著作権を譲渡するために必要かつ充分な権利及び能力を保有していることを保証します。また、アカウント管理者は、コンテンツの著作権に関し現在または将来なんら不利な要求が第三者より起こらないこと、及び万一そのような事態が生じた場合には、第三者からの一切の要求に対し、責任をもってこれを措置し、当社になんらの支障・損害を与えないことを保証します。
        </div>

        <h4>第３条：地域及び期間</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本規約に基づき、アカウント管理者が当社に対して譲渡する著作権の譲渡地域は、日本国内を含む全世界（一部の国と地域を除く）とします。</li>
            <li>本規約に基づく著作権譲渡の有効期間は、コンテンツのそれぞれにつき、当社の審査及び承認により当該コンテンツの著作権譲渡が効力を生じた日から起算して5年間とします。</li>
            <li>前項の期間満了の2ヵ月前までにアカウント管理者または当社の一方から他方に対し、当社所定の方式で反対の意思表示がなされない限り、著作権譲渡の有効期間は自動的に5年間延長されるものとします。その後の延長についても同様とします。</li>
          </ol>
        </div>

        <h4>第４条：譲渡の範囲</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本規約に基づき、アカウント管理者が当社に対して譲渡する著作権は、複製権（出版権、録音権、映画録音権等）、上演権、演奏権、上映権、公衆送信権、伝達権、口述権、譲渡権、貸与権、著作権法第27条及び第28条に規定する権利を含むものとします。</li>
            <li>当社は、コンテンツに関し、前項に定める権利を排他的に行使できるものとします。</li>
          </ol>
        </div>

        <h4>第５条：協力義務</h4>
        <div class="terms-text__box">
          アカウント管理者は、当社がコンテンツの移転の登録を行うに必要な一切の事項に関し、当社に対し協力義務を負うものとします。なお、期間満了または解除により著作権譲渡が終了した場合には、当社は、アカウント管理者に対し同様の協力義務を負うものとします。
        </div>

        <h4>第６条：著作権管理の方法</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、コンテンツの著作権について、以下に定める方法で管理を行うものとします。コンテンツの著作権の支分権または本件著作物（コンテンツを構成する著作物をいいます）の利用形態に関する以下の区分のうち、日本国内における⑩の区分については当社が自ら管理し、日本国内におけるこれ以外の区分については一般社団法人日本音楽著作権協会（以下「JASRAC」といいます）に委託します。</li>
          </ol>
        </div>

        <h4>区分</h4>
        <h4>JASRAC管理区分</h4>
        <div class="terms-text__box">
          <ul>
            <li>① 演奏権等（演奏権、上演権、上映権、公衆送信権及び口述権（何れも⑨から⑪までの利用形態に係る権利を除く）並びに伝達権を含む。）</li>
            <li>② 録音権等（録音権、頒布権及び録音物に係る譲渡権を含む。何れも⑨から⑪までの利用形態に係る権利を除く）</li>
            <li>③ 出版権等（出版権及び出版物に係る譲渡権を含む。何れも⑧から⑪までの利用形態に係る権利を除く）</li>
            <li>④ 貸与権</li>
            <li>⑤ 上映・BGM等の利用形態に係る権利</li>
            <li>⑥ 社交場・カラオケ演奏等の利用形態に係る権利</li>
            <li>⑦ 映画への録音の利用形態に係る権利</li>
            <li>⑧ ビデオグラムへの録音の利用形態に係る権利</li>
            <li>⑨ ゲームに供する目的で行う複製の利用形態に係る権利</li>
            <li>⑪ 放送・有線放送の利用形態に係る権利</li>
            <li>⑫ インタラクティブ配信の利用形態に係る権利</li>
            <li>⑬ 業務用通信カラオケの利用形態に係る権利</li>
          </ul>
        </div>

        <h4>当社管理区分</h4>
        <div class="terms-text__box">
          <ul>
            <li>⑩ 広告目的で行う複製の利用形態に係る権利</li>
          </ul>
          以上の区分は一般社団法人日本音楽著作権協会の管理委託契約約款の規定を基準とするものです。
        </div>

        <h4>第７条：アカウント管理者による利用</h4>
        <div class="terms-text__box">
          アカウント管理者は、非営利で利用する場合であって、アカウント管理者自らが利用主体となるときは、当社の同意を得た上でコンテンツを利用できるものとします。
        </div>

        <h4>第８条：著作権表示</h4>
        <div class="terms-text__box">
          当社は、コンテンツの複製物に当社が指定する著作権表示を行い、または行わせることができるものとします。
        </div>

        <h4>第９条：管理手数料</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は当社に対し、本サービスの管理手数料として、次に定める額を支払うものとします。</li>
            <ul>
              <li>(1)コンテンツが、本規約に基づきJASRACに管理を委託している区分で第三者により利用された場合において、当社が当該利用につきJASRACから受領した著作権使用料の額（以下「JASRAC管理著作権収益」といいます。）の15％相当額（諸税別）。</li>
              <li>(2)コンテンツが、当社が自ら管理する区分で第三者により利用された場合において、当社が当該利用につき当該第三者から受領した金額（以下「当社管理著作権収益」といいます。）に対し、当社とアカウント管理者が協議の上決定した料率を乗じた金額。</li>
            </ul>
            <li>前項の管理手数料の支払は、当社がJASRAC管理著作権収益又は当社管理著作権収益をアカウント管理者のアカウントに計上する時に管理手数料を控除する方法によるものとし、当該控除後の残額は、アカウント管理者が取得するものとします。</li>
          </ol>
        </div>

        <h4>第１０条：履行状況の説明</h4>
        <div class="terms-text__box">
          当社は、本規約の履行の状況に関して、アカウント管理者から請求を受けた場合には、本規約その他の関連規約の定めに従い、アカウント管理者に説明するものとします。
        </div>

        <h4>第１１条：第三者への権利譲渡等</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、アカウント管理者の同意を得ない限り、第三者（JASRACを除きます。）へのコンテンツの著作権の売却・譲渡等の処分を行ってはならないものとします。但し、当社が営業譲渡をし、吸収・合併され、または会社分割する場合、その著作権が他に移転するときはこの限りでないものとします。</li>
            <li>前項但書によりコンテンツの著作権が他に移転する場合には、当社は、当該移転前にアカウント管理者に対し移転先、移転予定日、移転理由、その他必要な事項を当社所定の方法により通知するものとします。但し、経営上の秘密その他やむを得ない事由により、移転前に通知ができなかった場合には、移転後速やかに同様の通知を行うものとします。</li>
          </ol>
        </div>

        <h4>第１２条：解除等</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社が次の各号のいずれかに該当した場合には、本規約に基づく著作権譲渡は、解除されたものとみなします。</li>
            <ul>
              <li>(1)破産の宣告</li>
              <li>(2)会社の解散決議</li>
            </ul>
            <li>アカウント管理者は、当社が営業活動を廃止した場合、または当社の本店及び営業所の所在がいずれも不明である場合には、本規約に基づく著作権譲渡を解除することができるものとします。</li>
            <li>アカウントが削除その他により失効した場合、及びアカウント管理者に対する本サービスの提供が中止・停止その他により失効した場合、本規約に基づく著作権譲渡は、解除されたものとみなします。</li>
          </ol>
        </div>

        <h4>第１３条：譲渡失効後の著作権の帰属</h4>
        <div class="terms-text__box">
          期間満了または解除により本規約に基づく著作権譲渡が失効した場合には、コンテンツの著作権は、当然アカウント管理者に帰属するものとします。
        </div>

        <h4>第１４条：権利承継の通知</h4>
        <div class="terms-text__box">
          当社は、相続、法人の合併、会社分割等によりアカウント管理者の権利の承継者が新たに生じた場合であっても、当該承継者から権利を証する文書を添えた承継の通知を受けた上で、当社所定の手続によりアカウントの変更または新規開設等の手続を完了しない限り、本規約に基づくアカウント管理者への著作権収益を従前のアカウント管理者のアカウントに計上し、または、当社が適当と認めるところに従い保管することができるとし、これにより本規約に基づく債務不履行の責任を負わないものとします。
        </div>

        <h4>第１５条：著作権等管理事業者との関係</h4>
        <div class="terms-text__box">
          アカウント管理者・当社の両当事者またはその一方が、著作権等管理事業者と委託契約を締結している場合には、アカウント管理者及び当社は、当該委託契約を尊重します。但し、アカウント管理者・当社間の関係においては、すべて本規約の定めるところに従うものとします。
        </div>

        <h4>第１６条：個人情報の取扱い</h4>
        <div class="terms-text__box">
          当社は、本規約に基づいてアカウント管理者から取得したアカウント管理者及び著作者に係る個人情報を著作権管理サービス利用規約に定める利用目的及びプライバシーポリシーに従って取り扱うものとします。
        </div>

        <h4>第１７条：規約の変更</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本規約は、当社の判断により事前の通知なく随時変更を行うことができるものとします。</li>
            <li>本規約を変更する場合、当社はその旨を変更後の規約の内容及び変更の効力発生日とともに、本サービスに係る当社所定のウェブサイト上に掲示し、又はアカウント管理者に通知するものとします。アカウント管理者はかかる掲示ないし通知を定期的に確認するものとします。</li>
          </ol>
        </div>

        <p>本規約は2024年4月16日より実施します。</p>
        <p>2024年4月1日制定</p>

        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
    <!-- eslint-enable max-len -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'CopyrightAssignmentTerms',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
